import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  FaArrowLeft, FaSave, FaTimes, FaUser, FaPhone,
  FaMapMarkerAlt, FaUsers, FaRing, FaPaperclip,
  FaTrash, FaDownload, FaFilePdf, FaFileImage, FaFileWord, FaFile, FaPlus, FaSpinner
} from 'react-icons/fa';
import api, { congregacaoService } from '../../services/api';
import SeletorResponsaveis from '../../components/SeletorResponsaveis';
import './CadastroIrmandade.css';

const iconeDoc = (mime) => {
  if (!mime) return <FaFile />;
  if (mime.includes('pdf'))   return <FaFilePdf   style={{ color: '#e53e3e' }} />;
  if (mime.includes('image')) return <FaFileImage  style={{ color: '#3182ce' }} />;
  if (mime.includes('word') || mime.includes('document')) return <FaFileWord style={{ color: '#2b6cb0' }} />;
  return <FaFile />;
};

const formatBytes = (b) => {
  if (!b) return '';
  if (b < 1024) return b + ' B';
  if (b < 1024 * 1024) return (b / 1024).toFixed(1) + ' KB';
  return (b / (1024 * 1024)).toFixed(1) + ' MB';
};

const mascaraCPF = (v) => {
  const d = v.replace(/\D/g, '').slice(0, 11);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0,3)}.${d.slice(3)}`;
  if (d.length <= 9) return `${d.slice(0,3)}.${d.slice(3,6)}.${d.slice(6)}`;
  return `${d.slice(0,3)}.${d.slice(3,6)}.${d.slice(6,9)}-${d.slice(9)}`;
};

const valorTriState = (value) => value === true ? 'true' : value === false ? 'false' : 'null';
const parseTriState = (value) => value === 'true' ? true : value === 'false' ? false : null;

const CadastroIrmandade = () => {
  const navigate = useNavigate();
  const { canWriteModule } = useAuth();
  const fileRef = useRef();

  useEffect(() => {
    if (!canWriteModule('irmandade')) {
      navigate('/irmandade', { replace: true });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [carregando, setCarregando] = useState(false);
  const [cargos, setCargos] = useState([]);
  const [carregandoCargos, setCarregandoCargos] = useState(false);
  const [potenciaisResponsaveis, setPotenciaisResponsaveis] = useState([]);
  const [carregandoResponsaveis, setCarregandoResponsaveis] = useState(false);
  const [congregacoes, setCongregacoes] = useState([]);
  const [loadingCongregacoes, setLoadingCongregacoes] = useState(true);
  const [membroCriadoId, setMembroCriadoId] = useState(null);
  const [documentos, setDocumentos] = useState([]);
  const [uploadInfo, setUploadInfo] = useState({ nome: '', arquivo: null });
  const [enviandoDoc, setEnviandoDoc] = useState(false);

  const [formData, setFormData] = useState({
    nome: '',
    cpf: '',
    data_nascimento: '',
    telefone: '',
    email: '',
    endereco: '',
    congregacao: '',
    congregacao_outra: '',
    genero: 'irmao',
    estado_civil: 'solteiro',
    responsavel_id: '',
    responsaveis: [],
    observacoes: '',
    comparece_reuniao: null,
    frequente_reuniao: null,
    batizado: null,
    visita_indicada: null,
    aceitou_visita: null,
    cargos_selecionados: []
  });

  const [erros, setErros] = useState({});

  const carregarCongregacoes = async () => {
    try {
      setLoadingCongregacoes(true);
      const response = await congregacaoService.getAtivas();
      if (response.success && response.data) setCongregacoes(response.data);
    } catch (error) {
      console.error('Erro ao carregar congregações:', error);
    } finally {
      setLoadingCongregacoes(false);
    }
  };

  useEffect(() => {
    carregarCargos();
    carregarPotenciaisResponsaveis();
    carregarCongregacoes();
  }, []);

  const carregarDocumentos = async () => {
    if (!membroCriadoId) return;
    try {
      const { data } = await api.get(`/irmandade/${membroCriadoId}/documentos`);
      setDocumentos(data);
    } catch { /* silencioso */ }
  };

  useEffect(() => {
    if (membroCriadoId) carregarDocumentos();
  }, [membroCriadoId]); // eslint-disable-line

  const carregarCargos = async () => {
    try {
      setCarregandoCargos(true);
      const response = await api.get('/cargos');
      setCargos(response.data);
    } catch (error) {
      console.error('Erro ao carregar cargos:', error);
    } finally {
      setCarregandoCargos(false);
    }
  };

  const carregarPotenciaisResponsaveis = async () => {
    try {
      setCarregandoResponsaveis(true);
      const response = await api.get('/irmandade/potenciais-responsaveis');
      setPotenciaisResponsaveis(response.data);
    } catch (error) {
      console.error('Erro ao carregar potenciais responsáveis:', error);
    } finally {
      setCarregandoResponsaveis(false);
    }
  };

  const calcularIdade = (dataNascimento) => {
    if (!dataNascimento) return null;
    const hoje = new Date();
    const nascimento = new Date(dataNascimento);
    let idade = hoje.getFullYear() - nascimento.getFullYear();
    const mesAtual = hoje.getMonth();
    const mesNascimento = nascimento.getMonth();
    
    if (mesAtual < mesNascimento || (mesAtual === mesNascimento && hoje.getDate() < nascimento.getDate())) {
      idade--;
    }
    
    return idade;
  };

  const determinarCategoria = (dataNascimento, estadoCivil) => {
    const idade = calcularIdade(dataNascimento);
    if (idade === null) return null;
    if (idade < 12) return 'crianca';
    if (estadoCivil === 'casado' || estadoCivil === 'divorciado') return 'adulto';
    return 'jovem';
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (erros[name]) setErros(prev => { const n = { ...prev }; delete n[name]; return n; });
  };

  const handleCargoChange = (cargoId) => {
    setFormData(prev => {
      const cargosAtuais = prev.cargos_selecionados || [];
      const jaExiste = cargosAtuais.includes(cargoId);
      return {
        ...prev,
        cargos_selecionados: jaExiste
          ? cargosAtuais.filter(id => id !== cargoId)
          : [...cargosAtuais, cargoId]
      };
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploadInfo({ nome: file.name.replace(/\.[^.]+$/, ''), arquivo: file });
  };

  const handleUploadDoc = async () => {
    if (!uploadInfo.arquivo || !membroCriadoId) return;
    setEnviandoDoc(true);
    try {
      const form = new FormData();
      form.append('arquivo', uploadInfo.arquivo);
      form.append('nome', uploadInfo.nome || uploadInfo.arquivo.name);
      await api.post(`/irmandade/${membroCriadoId}/documentos`, form, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setUploadInfo({ nome: '', arquivo: null });
      if (fileRef.current) fileRef.current.value = '';
      await carregarDocumentos();
    } catch (err) {
      alert(err?.response?.data?.error || 'Erro ao enviar documento.');
    } finally {
      setEnviandoDoc(false);
    }
  };

  const handleExcluirDoc = async (docId) => {
    if (!window.confirm('Excluir este documento?')) return;
    try {
      await api.delete(`/irmandade/${membroCriadoId}/documentos/${docId}`);
      setDocumentos(prev => prev.filter(d => d.id !== docId));
    } catch {
      alert('Erro ao excluir documento.');
    }
  };

  const handleDownloadDoc = (docId) => {
    const baseURL = `${window.location.protocol}//${window.location.hostname}:3001`;
    const token = localStorage.getItem('token');
    fetch(`${baseURL}/api/irmandade/${membroCriadoId}/documentos/${docId}/download`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(r => r.blob())
      .then(blob => {
        const doc = documentos.find(d => d.id === docId);
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url; a.download = doc?.nome || 'documento'; a.click();
        URL.revokeObjectURL(url);
      })
      .catch(() => alert('Erro ao baixar documento.'));
  };

  const validarFormulario = () => {
    const novosErros = {};
    
    if (!formData.nome.trim()) {
      novosErros.nome = 'Nome é obrigatório';
    }
    
    if (!formData.data_nascimento) {
      novosErros.data_nascimento = 'Data de nascimento é obrigatória';
    } else {
      const idade = calcularIdade(formData.data_nascimento);
      if (idade === null || idade < 0 || idade > 120) {
        novosErros.data_nascimento = 'Data de nascimento inválida';
      }
    }
    
    const congregacaoValor = formData.congregacao === '__outra__' ? formData.congregacao_outra?.trim() : formData.congregacao?.trim();
    if (!congregacaoValor) {
      novosErros.congregacao = formData.congregacao === '__outra__' ? 'Informe o nome da congregação' : 'Congregação é obrigatória';
    }
    
    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      novosErros.email = 'Email inválido';
    }
    
    setErros(novosErros);
    return Object.keys(novosErros).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validarFormulario()) {
      return;
    }
    
    try {
      setCarregando(true);
      
      const categoria = determinarCategoria(formData.data_nascimento, formData.estado_civil);
      
      const congregacaoEnvio = formData.congregacao === '__outra__' ? (formData.congregacao_outra || '').trim() : formData.congregacao;
      const opt = (v) => (v != null && String(v).trim() !== '' ? String(v).trim() : null);
      const dadosParaEnvio = {
        nome_completo:   formData.nome.trim(),
        cpf:             opt(formData.cpf?.replace(/\D/g, '')),
        data_nascimento: formData.data_nascimento,
        tipo_pessoa:     formData.genero,
        telefone:        opt(formData.telefone),
        email:           opt(formData.email),
        endereco:        opt(formData.endereco),
        congregacao:     congregacaoEnvio && congregacaoEnvio.trim() ? congregacaoEnvio.trim() : null,
        estado_civil:    formData.estado_civil,
        responsavel_id:  formData.responsaveis.find(r => r.principal)?.id ?? formData.responsaveis[0]?.id ?? null,
        responsaveis:    formData.responsaveis,
        observacoes:     opt(formData.observacoes)
      };
      
      const response = await api.post('/irmandade', dadosParaEnvio);
      const criadoResp = response.data?.data ?? response.data;
      const novoId = typeof criadoResp === 'object' ? criadoResp?.id : criadoResp;

      const dadosFrequencia = {
        comparece_reuniao: formData.comparece_reuniao,
        frequente_reuniao: formData.frequente_reuniao,
        visita_indicada: formData.visita_indicada,
        aceitou_visita: formData.aceitou_visita,
        ...(categoria === 'jovem' ? { batizado: formData.batizado } : {}),
      };
      if (Object.values(dadosFrequencia).some(valor => valor !== null)) {
        await api.patch(`/irmandade/${novoId}/frequencia`, dadosFrequencia);
      }

      // Se há cargos selecionados e o membro é jovem ou adulto, adicionar os cargos
      if (formData.cargos_selecionados.length > 0 && (categoria === 'jovem' || categoria === 'adulto')) {
        await api.post(`/irmandade/${novoId}/cargos`, { cargo_ids: formData.cargos_selecionados });
      }

      setMembroCriadoId(novoId);
    } catch (error) {
      console.error('Erro ao cadastrar membro:', error);
      if (error.response?.data?.message) {
        setErros({ geral: error.response.data.message });
      } else {
        setErros({ geral: 'Erro ao cadastrar membro. Tente novamente.' });
      }
    } finally {
      setCarregando(false);
    }
  };

  const idade = calcularIdade(formData.data_nascimento);
  const categoria = determinarCategoria(formData.data_nascimento, formData.estado_civil);
  const podeEscolherCargos = categoria === 'jovem' || categoria === 'adulto';
  const precisaResponsavel = categoria === 'crianca';
  const catLabel = { crianca: 'Criança', jovem: 'Jovem / Mocidade', adulto: 'Adulto' };

  // Tela pós-cadastro: anexar documentos ou concluir
  if (membroCriadoId) {
    return (
      <div className="cadastro-irmandade">
        <div className="cadastro-header">
          <button type="button" className="btn-voltar" onClick={() => navigate('/irmandade')}>
            <FaArrowLeft /> Voltar
          </button>
          <h1><FaUser /> Membro cadastrado</h1>
        </div>

        <div className="cadastro-form">
          <div className="form-section sucesso-cadastro">
            <p className="msg-sucesso">
              <strong>{formData.nome}</strong> foi cadastrado(a) com sucesso.
              Você pode anexar documentos abaixo ou concluir para voltar à lista.
            </p>
          </div>

          <div className="form-section">
            <h3><FaPaperclip /> Anexar documentos</h3>
            <div className="doc-upload-area">
              <input ref={fileRef} type="file" id="doc-file"
                accept=".pdf,.jpg,.jpeg,.png,.webp,.doc,.docx"
                onChange={handleFileChange}
                style={{ display: 'none' }} />
              <div className="doc-upload-row">
                <button type="button" className="btn-escolher-arquivo"
                  onClick={() => fileRef.current?.click()}>
                  <FaPlus /> Escolher arquivo
                </button>
                {uploadInfo.arquivo && (
                  <>
                    <input type="text" className="doc-nome-input"
                      placeholder="Nome do documento"
                      value={uploadInfo.nome}
                      onChange={e => setUploadInfo(p => ({ ...p, nome: e.target.value }))} />
                    <button type="button" className="btn-salvar-doc"
                      onClick={handleUploadDoc} disabled={enviandoDoc}>
                      {enviandoDoc ? <FaSpinner className="spinner" /> : <FaPlus />}
                      {enviandoDoc ? 'Enviando…' : 'Anexar'}
                    </button>
                    <button type="button" className="btn-cancelar-doc"
                      onClick={() => { setUploadInfo({ nome: '', arquivo: null }); if (fileRef.current) fileRef.current.value = ''; }}>
                      <FaTimes />
                    </button>
                  </>
                )}
              </div>
              {uploadInfo.arquivo && (
                <span className="doc-arquivo-escolhido">
                  {uploadInfo.arquivo.name} ({formatBytes(uploadInfo.arquivo.size)})
                </span>
              )}
              <span className="campo-dica">PDF, imagem (JPG/PNG) ou Word. Máx. 10 MB.</span>
            </div>

            {documentos.length > 0 && (
              <div className="doc-lista">
                {documentos.map(doc => (
                  <div key={doc.id} className="doc-item">
                    <span className="doc-icone">{iconeDoc(doc.tipoMime)}</span>
                    <span className="doc-nome">{doc.nome}</span>
                    <span className="doc-tamanho">{formatBytes(doc.tamanho)}</span>
                    <div className="doc-acoes">
                      <button type="button" title="Baixar" className="btn-doc-acao btn-doc-download"
                        onClick={() => handleDownloadDoc(doc.id)}><FaDownload /></button>
                      <button type="button" title="Excluir" className="btn-doc-acao btn-doc-excluir"
                        onClick={() => handleExcluirDoc(doc.id)}><FaTrash /></button>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {documentos.length === 0 && <p className="doc-vazio">Nenhum documento anexado.</p>}
          </div>

          <div className="form-actions">
            <button type="button" className="btn-cancelar"
              onClick={() => navigate(`/irmandade/editar/${membroCriadoId}`)}>
              Ir para edição
            </button>
            <button type="button" className="btn-salvar" onClick={() => navigate('/irmandade')}>
              <FaSave /> Concluir
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cadastro-irmandade">
      <div className="cadastro-header">
        <button 
          type="button" 
          className="btn-voltar"
          onClick={() => navigate('/irmandade')}
        >
          <FaArrowLeft /> Voltar
        </button>
        <h1><FaUser /> Novo Membro da Irmandade</h1>
      </div>

      <form onSubmit={handleSubmit} className="cadastro-form">
        {erros.geral && (
          <div className="erro-geral">
            {erros.geral}
          </div>
        )}

        <div className="form-section">
          <h3><FaUser /> Informações Pessoais</h3>
          
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="nome">Nome Completo *</label>
              <input
                type="text"
                id="nome"
                name="nome"
                value={formData.nome}
                onChange={handleInputChange}
                className={erros.nome ? 'erro' : ''}
                placeholder="Digite o nome completo"
              />
              {erros.nome && <span className="erro-texto">{erros.nome}</span>}
            </div>

            <div className="form-group" style={{ maxWidth: 200 }}>
              <label htmlFor="cpf">CPF</label>
              <input
                type="text"
                id="cpf"
                name="cpf"
                value={formData.cpf}
                onChange={e => setFormData(prev => ({ ...prev, cpf: mascaraCPF(e.target.value) }))}
                placeholder="000.000.000-00"
                maxLength={14}
                inputMode="numeric"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="data_nascimento">Data de Nascimento *</label>
              <input
                type="date"
                id="data_nascimento"
                name="data_nascimento"
                value={formData.data_nascimento}
                onChange={handleInputChange}
                className={erros.data_nascimento ? 'erro' : ''}
              />
              {erros.data_nascimento && <span className="erro-texto">{erros.data_nascimento}</span>}
              {idade !== null && (
                <span className="idade-info">
                  {idade} anos —{' '}
                  <strong style={{ color: categoria === 'crianca' ? '#3182ce' : categoria === 'jovem' ? '#6b46c1' : '#2d6a4f' }}>
                    {catLabel[categoria]}
                  </strong>
                </span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="genero">Gênero *</label>
              <select id="genero" name="genero" value={formData.genero} onChange={handleInputChange}>
                <option value="irmao">Irmão</option>
                <option value="irma">Irmã</option>
              </select>
            </div>
          </div>

          {/* Estado Civil — define Jovem vs Adulto */}
          {categoria !== 'crianca' && (
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="estado_civil">
                  <FaRing style={{ marginRight: 6 }} />
                  Estado Civil
                  <span style={{ fontSize: '.78rem', color: '#6b7280', marginLeft: 8 }}>
                    (define se é Jovem ou Adulto)
                  </span>
                </label>
                <select id="estado_civil" name="estado_civil"
                  value={formData.estado_civil} onChange={handleInputChange}
                  style={{ fontWeight: 500 }}>
                  <option value="solteiro">Solteiro(a) — Jovem / Mocidade</option>
                  <option value="casado">Casado(a) — Adulto</option>
                  <option value="divorciado">Divorciado(a) — Adulto</option>
                </select>
                <span className="campo-dica">
                  Jovens solteiros de qualquer idade são Mocidade. Casados ou divorciados são Adultos.
                </span>
              </div>
            </div>
          )}
        </div>

        <div className="form-section">
          <h3><FaPhone /> Contato</h3>
          
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="telefone">Telefone</label>
              <input
                type="tel"
                id="telefone"
                name="telefone"
                value={formData.telefone}
                onChange={handleInputChange}
                placeholder="(00) 00000-0000"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className={erros.email ? 'erro' : ''}
                placeholder="email@exemplo.com"
              />
              {erros.email && <span className="erro-texto">{erros.email}</span>}
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="endereco">Endereço</label>
              <input
                type="text"
                id="endereco"
                name="endereco"
                value={formData.endereco}
                onChange={handleInputChange}
                placeholder="Rua, número, bairro, cidade"
              />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3><FaMapMarkerAlt /> Congregação</h3>
          
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="congregacao">Congregação *</label>
              {loadingCongregacoes ? (
                <div className="loading-select">Carregando congregações...</div>
              ) : (
                <>
                  <select
                    id="congregacao"
                    name="congregacao"
                    value={
                      !formData.congregacao
                        ? ''
                        : congregacoes.some(c => c.nome === formData.congregacao)
                          ? formData.congregacao
                          : '__outra__'
                    }
                    onChange={(e) => setFormData(prev => ({
                      ...prev,
                      congregacao: e.target.value,
                      ...(e.target.value !== '__outra__' ? { congregacao_outra: '' } : {}),
                    }))}
                    className={erros.congregacao ? 'erro' : ''}
                  >
                    <option value="">Selecione uma congregação</option>
                    {congregacoes.map(c => (
                      <option key={c.id} value={c.nome}>{c.nome}</option>
                    ))}
                    <option value="__outra__">Outra (informar nome)</option>
                  </select>
                  {(formData.congregacao === '__outra__' || (formData.congregacao && !congregacoes.some(c => c.nome === formData.congregacao))) && (
                    <input
                      type="text"
                      name="congregacao_outra"
                      placeholder="Nome da congregação"
                      value={formData.congregacao === '__outra__' ? formData.congregacao_outra : formData.congregacao}
                      className="input-outra-congregacao"
                      style={{ marginTop: 8 }}
                      onChange={(e) => setFormData(prev => ({
                        ...prev,
                        congregacao_outra: e.target.value,
                        congregacao: '__outra__'
                      }))}
                    />
                  )}
                </>
              )}
              {erros.congregacao && <span className="erro-texto">{erros.congregacao}</span>}
            </div>
          </div>
        </div>

        {precisaResponsavel && (
          <div className="form-section">
            <h3><FaUsers /> Responsáveis</h3>
            <div className="form-row">
              <div className="form-group">
                {carregandoResponsaveis ? (
                  <span className="carregando-texto">Carregando responsáveis...</span>
                ) : (
                  <SeletorResponsaveis
                    potenciais={potenciaisResponsaveis}
                    value={formData.responsaveis}
                    onChange={(novo) => setFormData(prev => ({ ...prev, responsaveis: novo }))}
                    onMembroAdicionado={(criado) => {
                      if (!criado?.id) return;
                      setPotenciaisResponsaveis((prev) => {
                        if (prev.some((p) => Number(p.id) === Number(criado.id))) return prev;
                        return [...prev, {
                          id: criado.id,
                          nomeCompleto: criado.nomeCompleto || criado.nome_completo || '',
                          nome_completo: criado.nome_completo || criado.nomeCompleto || '',
                        }];
                      });
                      setFormData((prev) => {
                        if (prev.responsaveis.some((r) => Number(r.id) === Number(criado.id))) return prev;
                        return {
                          ...prev,
                          responsaveis: [
                            ...prev.responsaveis,
                            { id: criado.id, principal: prev.responsaveis.length === 0 },
                          ],
                        };
                      });
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        )}

        {podeEscolherCargos && (
          <div className="form-section">
            <h3><FaUsers /> Cargos</h3>
            
            {carregandoCargos ? (
              <div className="carregando-texto">Carregando cargos...</div>
            ) : (
              <div className="cargos-grid">
                {cargos.map(cargo => (
                  <label key={cargo.id} className="cargo-checkbox">
                    <input
                      type="checkbox"
                      checked={formData.cargos_selecionados.includes(cargo.id)}
                      onChange={() => handleCargoChange(cargo.id)}
                    />
                    <span className="cargo-nome">{cargo.nome}</span>
                  </label>
                ))}
              </div>
            )}
          </div>
        )}

        <div className="form-section">
          <h3><FaUsers /> Frequência e acompanhamento</h3>
          <span className="campo-dica frequencia-dica">
            Campos opcionais. Se ainda não houver confirmação, mantenha “Não informado”.
          </span>
          <div className="form-row frequencia-tristate-grid">
            {[
              ['comparece_reuniao', 'Comparece à reunião?'],
              ['frequente_reuniao', 'É frequente?'],
              ...(categoria === 'jovem' ? [['batizado', 'Batizado?']] : []),
              ['visita_indicada', 'Visita indicada?'],
              ['aceitou_visita', 'Aceitou visita?'],
            ].map(([campo, label]) => (
              <div className="form-group" key={campo}>
                <label htmlFor={campo}>{label}</label>
                <select
                  id={campo}
                  value={valorTriState(formData[campo])}
                  onChange={(e) => setFormData(prev => ({
                    ...prev,
                    [campo]: parseTriState(e.target.value),
                  }))}
                >
                  <option value="null">Não informado</option>
                  <option value="true">Sim</option>
                  <option value="false">Não</option>
                </select>
              </div>
            ))}
          </div>
        </div>

        <div className="form-section">
          <h3>Observações</h3>
          
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="observacoes">Observações</label>
              <textarea
                id="observacoes"
                name="observacoes"
                value={formData.observacoes}
                onChange={handleInputChange}
                rows="4"
                placeholder="Observações adicionais sobre o membro"
              />
            </div>
          </div>
        </div>

        <div className="form-actions">
          <button 
            type="button" 
            className="btn-cancelar"
            onClick={() => navigate('/irmandade')}
          >
            <FaTimes /> Cancelar
          </button>
          
          <button 
            type="submit" 
            className="btn-salvar"
            disabled={carregando}
          >
            <FaSave /> {carregando ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CadastroIrmandade;